(function ($, window) {
    // set size of the comparision slider
    function setSizes() {
        // get the width of the container
        var w = $('.cd-image-container').width();

        // set images to be the same width as container
        $('.cd-image-container img').width(w);

        // set crazy large arbitary height
        var h = 9999999;

        // for each image in the container
        $('.cd-image-container img').each(function () {
            // if the image height is smaller than the largest height found so far
            if ($(this).height() < h) {
                // set the smallest height
                h = $(this).height();
            }
        });

        // set the container to be the height of the smallest image
        $('.cd-image-container').height(h);
    }

    // set sizes on page ready
    $('.cd-image-container').imagesLoaded(function () {
        setSizes();
    });

    // set sizes on window resize
    $(window).on('resize', function () {
        setSizes();
    });

    // remove the tooltip when the handle is draggged
    $('.cd-handle').on('mousedown touchstart', function () {
        if ($('.cd-image-container .tool-tip').length) {
            $('.cd-image-container .tool-tip').fadeOut(200, function () {
                $(this).remove();
            });
        }
    });

    // setup drag dealer for the slider
    new Dragdealer('compare-slider', {
        x: 0.5,
        animationCallback: function (x, y) {
            // set the total % width
            var total = Math.round(x * 100);

            // apply to width of comparision
            $('.cd-before-image').width(total + '%');

            // determine the left offset of the handle
            // this will make its center align with the before/after edge
            var left = Math.round(x * 88) - 44;

            $('.cd-handle').css({
                'margin-left': left + 'px',
            });
        },
    });
})(jQuery, window);
